module.exports = __webpack_public_path__ + "arrow.svg?219cf27248997c0c9aa3ed1bbec32b61";